import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import calendar from '../../../assets/images/calendar.png';

@inject("store")
@observer
export default class CalendarImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <img src={calendar} alt="calendar" className="calendar-input-image"/>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CalendarImage.js